// Canonical sources of truth used across the site.
// Edit here, propagate everywhere.

export const SITE = {
  domain: "https://burgerconsult.com",
  name: "Burger Consulting",
  brand: "Burgerc_",
  email: "bastian@burgerconsult.com",
  twitter: "@BaNiBurger",
};

// Standard CTA copy. One label, one href, one voice.
export const CTA = {
  primary: {
    label: "Book a Free Intro Call",
    href: "/contact",
  },
  secondary: {
    label: "See how I work",
    href: "/about",
  },
  urgent: {
    label: "Request Rapid Response",
    href: "/services/rapid-response",
  },
};

// Canonical headline stats — keep in sync with About / Coaching.
export const STATS = {
  ceosCoached: { value: "50+", label: "CEOs & leadership teams coached" },
  startupsPerYear: { value: "100+", label: "Startups incubated per year" },
  portfolioRaised: { value: "€700M+", label: "Raised by portfolio" },
  foundersTaught: { value: "1,500+", label: "Founders taught" },
  productsBuilt: { value: "50+", label: "Products built" },
};

// Canonical client list. Casing matters — these are brand names.
export const COMPANIES = [
  "Konux",
  "Langfuse",
  "CedarDB",
  "Personio",
  "AskLio",
  "HappyRobot",
  "SimBricks",
  "SuperGlue",
];

// Subsets used in specific contexts.
export const COMPANIES_ENTERPRISE = ["Siemens", "BMW"];
